export class BuildCancelledError extends Error {
  constructor() {
    super("Scene build cancelled.");
    this.name = "BuildCancelledError";
  }
}
export function throwIfAborted(signal: AbortSignal): void {
  if (signal.aborted) throw new BuildCancelledError();
}
